module.exports = __webpack_public_path__ + "static/media/bucket-list.39690fcc.png";